// features/diagnostics/DenyLoggerMount.tsx
//
// Mounted once near the app root (sibling of the route tree). When an admin
// turns on config/denyLogging/enabled, every signed-in client starts capturing
// RTDB permission_denied events and reporting aggregates to /denyLog/{uid}.
// Renders nothing.

import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { subscribeDenyFlag, startDenyLogging, stopDenyLogging } from '../../utils/denyLogger';

export function DenyLoggerMount(): null {
  const { user } = useAuth();
  const uid = user?.uid;

  useEffect(() => {
    if (!uid) return;
    const name =
      `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email || 'Staff';
    const unsub = subscribeDenyFlag((enabled) => {
      if (enabled) startDenyLogging(uid, name);
      else stopDenyLogging();
    });
    return () => {
      unsub();
      stopDenyLogging();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  return null;
}

export default DenyLoggerMount;
